import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../molecules/RoundedModal'
import AddImageForm from './form'

const AddImageDialog = React.forwardRef(function AddImageDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => setDialogState({ open: true, processing: false })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Image'
      open={dialogState.open}
      onClose={close}
      size='full'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<AddImageForm onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

AddImageDialog.propTypes = {
  onComplete: PropTypes.func
}

AddImageDialog.defaultProps = {
  onComplete: () => {}
}

export default AddImageDialog
